export const makeHasAgentsRoleRegex = (role: string): string => {
  return `"${role}"`;
};
